<template>
  <div class="tools-scholarships">
    <div class="tool-title mb-4">
      Bolsas e Oportunidades
    </div>
    <blog-article
      v-if="blogArticle"
      :article="blogArticle"
      @clear="blogArticle = null"
    />
    <template v-else>
      <div class="filter-box">
        <i class="icon-search"></i>
        <input
          v-model="parameters.search"
          type="text"
          placeholder="Pesquisar"
          @input="searching"
        />
        <button class="filter-button" @click="filter = !filter">
          Filtrar resultados
          <i class="ml-2 icon-chevron-down" />
        </button>

        <div
          class="filters-popover"
          :class="{ open: filter }"
          v-click-outside="close"
        >
          <div class="d-flex mb-3">
            <filters
              class="filters"
              v-model="parameters.status"
              :items="[
                { id: 'enable', name: 'Abertas' },
                { id: 'disable', name: 'Fechadas' }
              ]"
              @input="search"
              unique
            />
            <button
              class="border-0 bg-transparent text-white font-weight-bold"
              @click="clearFilter"
            >
              Limpar
            </button>
          </div>

          <div class="d-flex mr-4">
            <action-dispatcher action="blog/getLevels">
              <div class="mb-2">Nível:</div>
              <filters
                v-model="parameters.level__in"
                :items="levels"
                @input="search"
              />
            </action-dispatcher>
            <hr />
            <action-dispatcher action="blog/getLocations">
              <div class="mb-2">Localização:</div>
              <filters
                v-model="parameters.location__in"
                :items="locations"
                @input="search"
              />
            </action-dispatcher>
            <hr />
            <action-dispatcher action="blog/getSubjects">
              <div class="mb-2">Área:</div>
              <filters
                v-model="parameters.subject__in"
                :items="subjects"
                @input="search"
              />
            </action-dispatcher>
          </div>
        </div>
      </div>

      <div class="row">
        <div class="col">
          <action-dispatcher
            action="blog/getArticles"
            :parameters="parameters"
            ref="actionDispatcher"
          >
            <div class="mt-3 text-secondary">{{ count }}</div>
            <initial-layout
              v-if="isInitial"
              :articles="articles"
              @open-article="openArticle"
            />
            <div v-else class="row">
              <div
                class="col-lg-4 py-4"
                v-for="(article, index) in articles"
                :key="index"
              >
                <article-link
                  :article="article"
                  @open-article="openArticle(article)"
                />
              </div>
            </div>

            <pagination
              :parameters="parameters"
              :articles="articles"
              @next="nextPage"
            />
          </action-dispatcher>
        </div>
      </div>
    </template>
  </div>
</template>
<script>
import ArticleLink from "@/components/blog/ArticleLink";
import Filters from "@/components/blog/Filters";
import InitialLayout from "@/components/blog/InitialLayout";
import Pagination from "@/components/blog/Pagination";
import BlogArticle from "@/components/tools/BlogArticle";
import get from "lodash/get";
import { mapState } from "vuex";

let timeout;
export default {
  components: { ArticleLink, Filters, Pagination, InitialLayout, BlogArticle },
  data() {
    return {
      parameters: {
        limit: 9,
        offset: 0,
        level__in: "",
        subject__in: "",
        status: "",
        location__in: "",
        search: ""
      },
      filter: false,
      blogArticle: null
    };
  },
  computed: {
    ...mapState("blog", [
      "articles",
      "locations",
      "subjects",
      "levels",
      "pagination"
    ]),
    count() {
      const count = get(this.pagination, "count", 0);
      return `${count} resultado${count != 1 ? "s" : ""} encontrado${
        count != 1 ? "s" : ""
      }`;
    },
    isInitial() {
      return (
        this.parameters.level__in === "" &&
        this.parameters.subject__in === "" &&
        this.parameters.status === "" &&
        this.parameters.location__in === "" &&
        this.parameters.search === "" &&
        this.parameters.limit == 9
      );
    }
  },
  methods: {
    close(e) {
      if (this.filter && !e.target.classList.contains("filter-button"))
        this.filter = false;
    },
    clearFilter() {
      this.parameters.level__in = "";
      this.parameters.subject__in = "";
      this.parameters.status = "";
      this.parameters.location__in = "";
      this.search();
    },
    searching() {
      clearTimeout(timeout);
      timeout = setTimeout(() => {
        this.search();
      }, 500);
    },
    search() {
      this.parameters.offset = 0;
      this.parameters.limit = 9;
      this.$refs.actionDispatcher.dispatch();
    },
    //Caso cliente queira voltar a paginação antiga remover esses cometanrios abaixo
    // prevPage() {
    //   this.parameters.offset -= this.parameters.limit;
    //   this.$refs.actionDispatcher.dispatch();
    // },
    nextPage() {
      this.parameters.limit += 3;
      //Caso cliente queira voltar a paginação antiga remover  codigos acima e habilitar codigo comentado
      //this.parameters.offset += this.parameters.limit;
      this.$refs.actionDispatcher.dispatch();
      if (this.parameters.limit == 12) {
        window.scrollTo(0, 0);
      }
    },
    openArticle(article) {
      this.blogArticle = article;
    }
  }
};
</script>

<style lang="scss" scoped>
.tools-scholarships {
  .filter-box {
    padding: 16px 24px;
    background-color: rgba(36, 36, 36, 1);
    border-radius: 8px;
    display: grid;
    grid-template-columns: auto 1fr auto;
    align-items: center;
    gap: 16px;
    position: relative;

    i {
      font-size: 20px;
    }
    i,
    input {
      background-color: transparent;
      border: none;
      outline: none;
      color: white;
    }
    input::placeholder {
      color: rgba(146, 143, 152, 1);
    }
    .filter-button {
      display: inline-flex;
      background-color: transparent;
      color: white;
      border: none;
      align-items: center;
      border-left: 1px solid rgba(146, 143, 152, 1);
      padding-left: 16px;
      font-weight: bold;
      transition: color 0.1s;
      max-height: 450px;
      &:hover {
        cursor: pointer;
        color: rgba(146, 143, 152, 1);
        i {
          color: rgba(146, 143, 152, 1);
        }
      }
      i {
        transition: color 0.1s;
        font-size: 24px !important;
      }
    }

    .filters-popover {
      display: none;
      position: absolute;
      top: calc(100% + 8px);
      right: 0;
      background-color: rgba(36, 36, 36, 1);
      padding: 30px;
      z-index: 5;
      max-height: 450px;
      overflow-y: scroll;
      &.open {
        display: block;
      }
      .filters {
        display: flex;
        gap: 16px;
        flex: 1;
      }
      & > .d-flex {
        gap: 24px;
      }
    }
  }
}
</style>
